const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcpaPrivacyoptions(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34px",
    height: "16px",
    viewBox: "0 0 34 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.386719 14.628906 L 16.09375 14.628906 L 19.605469 1.371094 L 8.386719 1.371094 C 4.761719 1.371094 1.8125 4.34375 1.8125 8 C 1.8125 11.65625 4.761719 14.628906 8.386719 14.628906 Z M 8.386719 14.628906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,40%,100%)",
      fillOpacity: 1
    },
    d: "M 25.613281 0 L 8.386719 0 C 3.964844 0 0.453125 3.542969 0.453125 8 C 0.453125 12.457031 3.964844 16 8.386719 16 L 25.613281 16 C 30.035156 16 33.546875 12.457031 33.546875 8 C 33.546875 3.542969 29.921875 0 25.613281 0 Z M 1.8125 8 C 1.8125 4.34375 4.761719 1.371094 8.386719 1.371094 L 19.605469 1.371094 L 16.09375 14.628906 L 8.386719 14.628906 C 4.761719 14.628906 1.8125 11.65625 1.8125 8 Z M 1.8125 8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 27.878906 4.570312 C 28.105469 4.800781 28.105469 5.257812 27.878906 5.484375 L 25.5 8 L 27.992188 10.515625 C 28.21875 10.742188 28.21875 11.199219 27.992188 11.429688 C 27.765625 11.65625 27.3125 11.65625 27.085938 11.429688 L 24.59375 8.914062 L 22.101562 11.429688 C 21.875 11.65625 21.421875 11.65625 21.191406 11.429688 C 20.964844 11.199219 20.964844 10.742188 21.191406 10.515625 L 23.574219 8 L 21.078125 5.484375 C 20.851562 5.257812 20.851562 4.800781 21.078125 4.570312 C 21.308594 4.34375 21.761719 4.34375 21.988281 4.570312 L 24.480469 7.085938 L 26.972656 4.570312 C 27.199219 4.34375 27.652344 4.34375 27.878906 4.570312 Z M 27.878906 4.570312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,40%,100%)",
      fillOpacity: 1
    },
    d: "M 14.394531 4.6875 C 14.621094 4.914062 14.734375 5.371094 14.507812 5.601562 L 9.746094 11.199219 C 9.632812 11.3125 9.519531 11.429688 9.40625 11.429688 C 9.179688 11.542969 8.839844 11.542969 8.613281 11.3125 L 6.121094 8.800781 C 5.894531 8.570312 5.894531 8.113281 6.121094 7.886719 C 6.347656 7.65625 6.800781 7.65625 7.027344 7.886719 L 9.066406 9.828125 L 13.375 4.6875 C 13.601562 4.457031 14.054688 4.457031 14.394531 4.6875 Z M 14.394531 4.6875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcpaPrivacyoptions);
export default __webpack_public_path__ + "static/media/ccpa-privacyoptions.84058322061fa09d39f2ad720259fcf3.svg";
export { ForwardRef as ReactComponent };